/**
 * @func escapeStringRegExp
 * @module escape-string-regexp
 * @memberOf matcher
 * @since 3.0.0
 *
 * @param  {string} str string to escape
 * @return {string} escaped string
 *
 * {@link https://github.com/sindresorhus/escape-string-regexp escape-string-regexp}
 * @see {@link escape-string-regexp *} 🍴
 *
 * @NOTE also as const escapeStringRegexp = require('escape-string-regexp');
 *
 * @example
 *
 *    const escaped = escapeStringRegexp('how much $ for a unicorn?');
 *    //=> 'how much \$ for a unicorn\?'
 *    new RegExp(escaped);
 *
 */
module.exports = function (str) { return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'); }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjYXBlLXN0cmluZy1yZWdleC5qcyIsInNvdXJjZXMiOlsiZXNjYXBlLXN0cmluZy1yZWdleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEBmdW5jIGVzY2FwZVN0cmluZ1JlZ0V4cFxuICogQG1vZHVsZSBlc2NhcGUtc3RyaW5nLXJlZ2V4cFxuICogQG1lbWJlck9mIG1hdGNoZXJcbiAqIEBzaW5jZSAzLjAuMFxuICpcbiAqIEBwYXJhbSAge3N0cmluZ30gc3RyIHN0cmluZyB0byBlc2NhcGVcbiAqIEByZXR1cm4ge3N0cmluZ30gZXNjYXBlZCBzdHJpbmdcbiAqXG4gKiB7QGxpbmsgaHR0cHM6Ly9naXRodWIuY29tL3NpbmRyZXNvcmh1cy9lc2NhcGUtc3RyaW5nLXJlZ2V4cCBlc2NhcGUtc3RyaW5nLXJlZ2V4cH1cbiAqIEBzZWUge0BsaW5rIGVzY2FwZS1zdHJpbmctcmVnZXhwICp9IPCfjbRcbiAqXG4gKiBATk9URSBhbHNvIGFzIGNvbnN0IGVzY2FwZVN0cmluZ1JlZ2V4cCA9IHJlcXVpcmUoJ2VzY2FwZS1zdHJpbmctcmVnZXhwJyk7XG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiAgICBjb25zdCBlc2NhcGVkID0gZXNjYXBlU3RyaW5nUmVnZXhwKCdob3cgbXVjaCAkIGZvciBhIHVuaWNvcm4/Jyk7XG4gKiAgICAvLz0+ICdob3cgbXVjaCBcXCQgZm9yIGEgdW5pY29yblxcPydcbiAqICAgIG5ldyBSZWdFeHAoZXNjYXBlZCk7XG4gKlxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHN0ciA9PiBzdHIucmVwbGFjZSgvW3xcXFxce30oKVtcXF1eJCsqPy5dL2csICdcXFxcJCYnKVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFxQkEsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFBLEdBQUcsQ0FBQSxDQUFDLEFBQUcsU0FBQSxHQUFHLENBQUMsT0FBTyxDQUFDLHFCQUFxQixFQUFFLE1BQU0sQ0FBQyxHQUFBOyJ9